import React from "react";
import styled from 'styled-components/macro';

interface PropsI {
  children?: React.ReactNode;
}

const PanelChildren = (props: PropsI) => {
  return(
    <Children>
      {props.children}
    </Children>
  )
}
export default PanelChildren;

interface ExtraProps {
  scrollY?: boolean;
  hasBorder?: boolean;
  children?: React.ReactNode;
}

const Children = styled.div<ExtraProps>`
  border-radius: ${(p) => p.theme.borderRadius};
  overflow-y: ${(p) => {
  return p.scrollY ? 'scroll' : 'none';
}};
`;